@if (itemList && itemList.length > 0) {
  <div class="margin-bottom-50">
    <div class="flex pad-vertical-10">
      @if (iconClass) {
        <span class="margin-right-10 bold-header font-size-2" [ngClass]="iconClass"></span>
      }
      @if (headerContentRef) {
        <span
          dsContent
          class="block-header"
          [options]="headerContentRef.options || null"
          [contentPath]="headerContentRef.path"
        ></span>
      }
    </div>
    <amfam-quote-summary [summaryList]="itemList"></amfam-quote-summary>
  </div>
}
